import { render, staticRenderFns } from "./MisSugerenciasPage.vue?vue&type=template&id=581dd68c"
import script from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"
export * from "./MisSugerenciasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports